function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M20,3c0-1.1-0.9-2-2-2H2C0.9,1,0,1.9,0,3l0,12c0,1.1,0.9,2,2,2h6.1c1.3,1.2,3,2,4.9,2c3.9,0,7-3.1,7-7 c0-0.3,0-0.7-0.1-1H20V3z M18,3l-3.5,2.2C14,5.1,13.5,5,13,5c-1.8,0-3.5,0.7-4.8,1.9L2,3H18z M2,5l5.1,3.2C6.4,9.3,6,10.6,6,12 c0,1.1,0.3,2.1,0.7,3H2V5z M13,17c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5s5,2.2,5,5C18,14.8,15.8,17,13,17z M16.5,5.9L18,5v2.1 C17.6,6.7,17,6.3,16.5,5.9z M12,14h2v2h-2V14z M12,8h2v4h-2V8z"
});

var SvgEmailReminder = function SvgEmailReminder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailReminder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email_reminder.33258549.svg";
export { ForwardRef as ReactComponent };